import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { useParams } from "react-router-dom";
import jsPDF from "jspdf";
import "../../../../../assets/css/style.css";
import { getCandidate } from "../../../../redux/actions/admin/CandidateActions";
import localStorageService from "../../../../services/localStorageService";
import moment from "moment";
import "moment/locale/fr";
import { CircularProgress } from "@material-ui/core";

const ResumeTemplate7 = (props) => {
  const { storeCandidate, getCandidate } = props;
  const [candidateId, setCandidatId] = React.useState("");
  const [candidate, setCandidate] = React.useState(null);
  const [isLoading, setIsLoading] = React.useState(true);

  useEffect(() => {
    let candidate = localStorageService.getItem("malibaara_auth_candidate");
    if (candidate) {
      setCandidatId(candidate?.id);
    }

    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    if (candidateId != "") {
      if (storeCandidate.candidate === null) {
        setIsLoading(true);
        getCandidate(candidateId).then((resp) => {
          setCandidate(resp);
          setIsLoading(false);
        });
      } else if (storeCandidate.candidate !== null) {
        setIsLoading(true);
        setCandidate(storeCandidate.candidate);
        setIsLoading(false);
      }
    }
  }, [candidateId]);

  const downloadPDF = () => {
    const doc = new jsPDF();
    doc.html(document.querySelector(".template-page"), {
      callback: (doc) => {
        doc.save("resume.pdf");
      },
    });
  };

  return (
    <React.Fragment>
      {isLoading ? (
        <div className="loading-container">
          <CircularProgress />
          <div>Chargement du cv en cours...</div>
        </div>
      ) : (
        <>
          <div className="template-page">
            <style>
              {`
                body {
                  font-family: 'Roboto', sans-serif !important;
                  line-height: 1.6 !important;
                  color: #333 !important;
                  margin: 0 !important;
                  padding: 0 !important;
                }
                .container {
                  width: 80% !important;
                  margin:0 auto !important;
                  padding: 30px !important;

                }
                header {
                  text-align: center;
                  margin-bottom: 30px;
                }
                header h1 {
                  color: #333;
                  font-size: 36px;
                  margin: 0;
                }
                header p {
                  font-size: 18px;
                  color: #666;
                  margin-top: 10px;
                }
                .section {
                  margin-bottom: 30px;
                }
                .section h2 {
                  font-size: 24px;
                  color: #333;
                  border-bottom: 2px solid #333;
                  padding-bottom: 5px;
                  margin-bottom: 15px;
                }
                .section ul {
                  list-style-type: none;
                  padding: 0;
                }
                .section ul li {
                  margin-bottom: 10px;
                }
                .section .title {
                  font-weight: bold;
                  font-size: 18px;
                  color: #333;
                }
                .section .details {
                  margin-left: 20px;
                  font-size: 16px;
                  color: #666;
                }
                .skills {
                  margin-bottom: 30px;
                }
                .skills h2 {
                  font-size: 24px;
                  color: #333;
                  margin-bottom: 15px;
                }
                .skills ul {
                  list-style-type: none;
                  padding: 0;
                  display: flex;
                  flex-wrap: wrap;
                }
                .skills li {
                  background-color: #f0f0f0;
                  color: #333;
                  padding: 8px 15px;
                  border-radius: 20px;
                  margin-right: 10px;
                  margin-bottom: 10px;
                  font-size: 14px;
                }
                .languages {
                  margin-bottom: 30px;
                }
                .languages h2 {
                  font-size: 24px;
                  color: #333;
                  margin-bottom: 15px;
                }
                .languages ul {
                  list-style-type: none;
                  padding: 0;
                  display: flex;
                  flex-wrap: wrap;
                }
                .languages li {
                  background-color: #f0f0f0;
                  color: #333;
                  padding: 8px 15px;
                  border-radius: 20px;
                  margin-right: 10px;
                  margin-bottom: 10px;
                  font-size: 14px;
                }
                .hobbies {
                  margin-bottom: 30px;
                }
                .hobbies h2 {
                  font-size: 24px;
                  color: #333;
                  margin-bottom: 15px;
                }
                .hobbies ul {
                  list-style-type: none;
                  padding: 0;
                }
                .hobbies li {
                  font-size: 16px;
                  color: #666;
                  margin-bottom: 10px;
                }
                .button-container {
                        position: fixed;
                        right: 20px;
                        top: 50%;
                        transform: translateY(-50%);
                        display: flex;
                        flex-direction: column;
                        gap: 10px;
                }

                .btn {
                    padding: 12px 20px;
                    font-size: 16px;
                    cursor: pointer;
                    border: none;
                    border-radius: 5px;
                    color: #fff;
                    background-color: #333;
                }

                .btn-download {
                    background-color: #5cb85c;
                }
                @media print {
                  body {
                    background-color: #fff;
                  }
                  .container {
                    box-shadow: none;
                    border: none;
                    padding: 0;
                    border-radius: 0;
                  }
                  .button-container {
                    display: none;
                  }
                  footer, .button-container {
                    display: none;
                  }
                }
              `}
            </style>
            <div className="container">
              <header>
                <h1>
                  {candidate?.firstName} {candidate?.lastName}
                </h1>
                <p>
                  Email: {candidate?.email} | Phone: {candidate?.phoneNumber1}
                </p>
              </header>
              <div className="section">
                <h2>Sommaire</h2>
                <div
                  className="html-content"
                  dangerouslySetInnerHTML={{ __html: candidate?.summary }}
                />
              </div>
              <div className="section">
                <h2>Expérience Professionnelle</h2>
                <ul>
                  {candidate?.workExperiences.map((job, index) => (
                    <li key={index}>
                      <div className="title">
                        {job.title} at {job.companyName}
                      </div>
                      <div className="details">
                        {moment(job.startDate).format("DD-MMMM-YYYY")} à{" "}
                        {moment(job.endDate).format("DD-MMMM-YYYY")}
                      </div>
                      <ul className="details">
                        <li>{job?.description}</li>
                      </ul>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="section">
                <h2>Parcours scolaire</h2>
                <ul>
                  {candidate?.educations.map((edu, index) => (
                    <li key={index}>
                      <div className="title">{edu.degree}</div>
                      <div className="details">
                        {edu.institute}, {edu.startYear} - {edu.endYear}
                      </div>
                    </li>
                  ))}
                </ul>
              </div>
              <div className="section skills">
                <h2>Compétences Professionnelles</h2>
                <ul>
                  {candidate?.skills.map((skill, index) => (
                    <li key={index}>{skill.title}</li>
                  ))}
                </ul>
              </div>
              <div className="section languages">
                <h2>Langues</h2>
                <ul>
                  {candidate?.languages?.map((language, index) => (
                    <li>{language.name}</li>
                  ))}
                </ul>
              </div>

              <div className="button-container">
                <button
                  className="btn btn-print"
                  onClick={() => window.print()}
                >
                  Imprimer mon CV
                </button>
                <button className="btn btn-download" onClick={downloadPDF}>
                  Télécharger le PDF
                </button>
              </div>
            </div>
          </div>
        </>
      )}
    </React.Fragment>
  );
};
ResumeTemplate7.propTypes = {
  storeCandidate: PropTypes.object.isRequired,
  getCandidate: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  storeCandidate: state.candidate,
});

export default connect(mapStateToProps, {
  getCandidate,
})(ResumeTemplate7);
